import { z } from 'zod';

export const informativeEventRequestZod = z.object({
  event: z.string(),
  entityRef: z.string().optional(),
  entityName: z.string().optional(),
});
